import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'semantic-ui-react'
import { css } from 'aphrodite'
import createStyles, { fontWeights } from './styles'
import { Text } from './Text'

export class TextField extends React.PureComponent {
  render() {
    const { meta = {}, input = {}, label, hint, ...props } = this.props
    const styles = getStyles(props, this.context)

    return (
      <Form.Field
        error={!!(meta.touched && meta.error)}
        className={css(styles.root)}
      >
        {label && <label className={css(styles.label)}>{label}</label>}

        <Input error={!!(meta.touched && meta.error)} {...props} {...input} />

        {hint && (
          <div className={css(styles.hint)}>
            <Text size="small" weight="light">
              {hint}
            </Text>
          </div>
        )}

        {meta.touched &&
          meta.error && (
            <div className={css(styles.error)}>
              <Text size="small" color="error" weight="light">
                {meta.error}
              </Text>
            </div>
          )}
      </Form.Field>
    )
  }
}

TextField.contextTypes = {
  theme: PropTypes.object,
}

const getStyles = createStyles((props, context, theme) => ({
  root: {
    marginBottom: 35,
  },

  label: {
    color: theme.colors.text,
    display: 'block',
    fontWeight: fontWeights.bold,
    marginBottom: 7,
  },

  hint: {
    marginTop: 7,
  },

  error: {
    marginTop: 7,
  },
}))



// WEBPACK FOOTER //
// ./src/components/TextField.js